import React, {Component} from 'react';
import Modal from 'react-modal';
import urlHandler   from '../../utils/urlHandler';
import noImageAvailable from '../../styles/images/no-image-available.png';
import ReactTooltip from 'react-tooltip';
import {findDOMNode} from 'react-dom'
import GeoUtils from '../../utils/geoUtils';
import IPUtils from '../../utils/ipv4Utils';

class SentenceWithTooltip extends Component {
    constructor(props) {
        super(props);

        this.renderContents = this.renderContents.bind(this);
        this.handleFeedback = this.handleFeedback.bind(this);

        this.uniqueId = 'id-' + Math.random().toString(36).substr(2, 16);
        this.bbcId = 'bbc-' + this.uniqueId;

        this.state = {
            showBaseballCard: false,
            baseballcard: null,
            class: 'bbc-sentiment-base',
            place: 'top',
            offset: {
                right: 0,
                top: 0
            }
        }
    }

    componentDidMount() {
        if (this.props.sentence) {
            this.setState({
                baseballcard: {
                    class: this.props.sentence.class,
                    classConfidence: this.props.sentence.classConfidence,
                    score: this.props.sentence.score,
                    text: this.props.sentence.text,
                    topic: 'topic' in this.props.sentence ? this.props.sentence.topic : null
                }
            })
        }
    }

    handleFeedback(sentence, e) {
        ReactTooltip.hide();
        this.props.handleFeedback(sentence);
    }
    
    renderContents() {
        if (this.state.baseballcard) {
            return(
                <div className="bbc-sentiment" ref={this.bbcId}>
                    <div className="bbc-sentiment-header">
                        <div className="bbc-sentiment-label">Sentence</div>          
                    </div>
                    <div className="bbc-sentiment-description">
                        <div>{this.state.baseballcard.text}</div>
                    </div>
                    <div className="bbc-sentiment-meta">
                        {this.state.baseballcard.class &&
                            <div className="bbc-sentiment-meta-entry">Class: {this.state.baseballcard.class}</div>
                        }
                        {this.state.baseballcard.classConfidence &&
                            <div className="bbc-sentiment-meta-entry">Confidence: {this.state.baseballcard.classConfidence.toFixed(4)}</div>
                        }
                        {(this.state.baseballcard.score !== undefined) &&
                            <div className="bbc-sentiment-meta-entry">Score: {this.state.baseballcard.score.toFixed(4)}</div>
                        }
                        {(this.state.baseballcard.topic) &&
                            <div className="bbc-sentiment-meta-entry">Topic: {this.state.baseballcard.topic}</div>
                        }
                    </div>
                </div>
            )
        } else {
            return (<div></div>)
        }
    }

    render() {
        const {sentence} = this.props;

        const cssClassName = 'class' in sentence ? sentence.class+'-sent' : '';
        const showCard = 'class' in sentence;

        return(
            <span>
                {showCard ?
                    <span style={{cursor:'pointer', whiteSpace: 'pre-line'}} data-tip data-for={this.uniqueId} className={cssClassName}
                        onMouseUp={this.handleFeedback.bind(this, sentence)}>
                        {sentence.text} </span>
                    : <span style={{whiteSpace: 'pre-line'}}>{sentence.text} </span>
                }
                <ReactTooltip id={this.uniqueId} 
                        type='dark' 
                        effect='solid' 
                        place='top'
                        delayShow={600} 
                        class={this.state.class}>
                        { this.renderContents() }
                </ReactTooltip>
            </span>
        )
    }
}

export default SentenceWithTooltip;